import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppConfigService } from '../configurations/app-config.service';
import { CommonService } from '../services/common.service';
import { forEach } from 'jszip';
declare const copyToClipboard: any;

@Component({
  selector: 'app-vbjobsdisplay',
  templateUrl: './vbjobsdisplay.component.html',
  styleUrls: ['./vbjobsdisplay.component.scss']
})
export class VbjobsdisplayComponent implements OnInit {
  @Input() inputDataInModalComponent: any;

  constructor(private ngxUiLoaderService: NgxUiLoaderService,
    public service: CommonService,
    private activeModal: NgbActiveModal,
    private _fb: FormBuilder,
    private modalService: NgbModal,
    private router: Router,
    private toastr: ToastrService) { }

  pagerolepermisions: any = [];
  devicejobdetails:any=[]
  async ngOnInit() {
    if (await this.service.checksession() == true) {
      const menuid = JSON.parse(sessionStorage.getItem('rolewithmenus')).find(x => x.RoleName == sessionStorage.getItem('SelectedUserRole')).menuslist.find(y => y.MenuName == 'createpipeline').MenuId;
      const actionitems = JSON.parse(sessionStorage.getItem('rolewithmenus')).find(x => x.RoleName == sessionStorage.getItem('SelectedUserRole')).menuslist.filter(y => y.ParentMenuId == menuid);
      actionitems.forEach(element => {
        this.pagerolepermisions[element.MenuName] = true;
      });
      if (this.pagerolepermisions != undefined) {
        this.routename = this.inputDataInModalComponent.routename;
        if(this.inputDataInModalComponent.JobType=='Device'){
        this.jobdetailslist(this.inputDataInModalComponent.data);
        }
        else{
          this.getvbjobslist(this.inputDataInModalComponent.data);
        }
      }
    }
  }

  vbagentid: string;
  seguid: string;
  deguid: string;
  VBjoblistMappedtoRoute: any[] = [];
  VBjoblist: any[] = [];
  routename: string;
  vbjobname:string;
  vbjobid:string;
  routevbjobnotfound: boolean = false;
  vbtype:any[]=[];
  async getvbjobslist(response) {
                  if (response != undefined && response.length > 0) {
                      this.VBjoblistMappedtoRoute = [];
                      this.VBjoblist = [];
  
                      this.VBjoblistMappedtoRoute = response;
  
                      this.routevbjobnotfound = this.VBjoblistMappedtoRoute.length == 0;
                      response.forEach(element => {
                        let arr=[];
                        for (let [key, value] of Object.entries(element)) {
                          
                          let vbObj: any = {};
                                    vbObj['name'] = [key].toString();
                                    vbObj['value'] =[value].toString();
                                    if(vbObj['name'].toLowerCase()!='delete'){
                                      arr.push(vbObj);
                                    if(vbObj['name'].toLowerCase()=='devicename'){
                                      this.vbtype.push(vbObj['value']);
                                    }
                                    }
                        }
                        if(arr.length>0){
                        this.VBjoblist.push(arr);
                        }
                      });
                      
                  } else {
                      this.toastr.error("VB Job Details Not Found", "", {
                          timeOut: 4000,
                          positionClass: 'toast-bottom-right'
                      });
                  }
}


  currentlyOpenedItemIndex = -1;

  setOpened(itemIndex) {
    this.currentlyOpenedItemIndex = itemIndex;
  }

  setClosed(itemIndex) {
    if (this.currentlyOpenedItemIndex === itemIndex) {
      this.currentlyOpenedItemIndex = -1;
    }
  }

  copyToClips(event: any, message: string) {
    if (event != '') {
      copyToClipboard(event);
      this.toastr.success(message + " " + "Copied", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    }
  }

  closetpopup() {
    this.activeModal.close();
  }

  jobname:any=''
  jobdetailslist(data){
    this.devicejobdetails=[];
    if(typeof data=='object'){                          
      for(let [key,value] of Object.entries(data)){
        let obj={}
        if(key=='JobName'){
          this.jobname=[value]
        }
        if(key!='ConnectivityInfo'){
         obj={
          name:key,
          value:value
        }
        this.devicejobdetails.push(obj);
      }else{
        obj={
          name:'RemoteIP',
          value:value['RemoteIP']
        }
        this.devicejobdetails.push(obj);
        obj={
          name:'RemotePort',
          value:value['RemotePort']
        }
        this.devicejobdetails.push(obj);
      }
      }
    }
  }
}
